import React, { useState } from "react";
import "./FAQ.css";

const faqLeft = [
  {
    id: 1,
    question: "How can I book a Sai Shirdi cab?",
    answer:
      "You can book your Sai Shirdi cab by calling us, sending a WhatsApp message, or submitting an enquiry through our website. Our team is available 24×7 to confirm your cab booking and pickup details.",
  },

  {
    id: 2,
    question: "Do you provide doorstep pickup for Shirdi trips?",
    answer:
      "Yes. We provide convenient doorstep pickup from Mumbai, Navi Mumbai and nearby suburbs. You can choose your preferred pickup location and travel comfortably directly to Shirdi.",
  },

  {
    id: 3,
    question: "Do you offer one-way and round-trip Sai Shirdi cab services?",
    answer:
      "Yes. We provide both one-way and round-trip cab services for Shirdi. You can choose the option that best suits your travel plans and Sai Baba Darshan schedule.",
  },

  {
    id: 4,
    question: "Which cars are available for Sai Shirdi cab booking?",
    answer:
      "We offer a wide range of comfortable vehicles including Swift Dzire, Maruti Ertiga, Toyota Rumion, Kia Carens, Innova, Innova Crysta and other vehicles suitable for families, couples and groups travelling to Shirdi.",
  },
];

const faqRight = [
  {
    id: 5,
    question: "How long does a Shirdi cab journey take?",
    answer:
      "The journey time depends on your pickup location, traffic, road conditions and stops during the trip. Our experienced drivers plan the journey for a comfortable and convenient travel experience.",
  },

  {
    id: 6,
    question: "Can I book a cab for Sai Baba Darshan in Shirdi?",
    answer:
      "Yes. Our Sai Shirdi cab service is ideal for Sai Baba Darshan trips. We can provide pickup and drop services according to your travel schedule, making your pilgrimage journey comfortable and hassle-free.",
  },

  {
    id: 7,
    question: "Do you provide Shirdi return cab service?",
    answer:
      "Yes. We provide return taxi services from Shirdi with flexible pickup options. You can book a one-way return cab or plan a complete round trip according to your travel requirements.",
  },

  {
    id: 8,
    question: "Is Sai Shirdi cab service available 24×7?",
    answer:
      "Yes. Our Sai Shirdi cab booking service is available 24×7, including weekends and public holidays. You can contact us anytime to check vehicle availability and confirm your journey.",
  },
];

function AccordionItem({ item, active, setActive }) {
  const open = active === item.id;

  return (
    <div className="faq-item">
      <button
        className="faq-question"
        onClick={() => setActive(open ? null : item.id)}
      >
        <span>
          {item.id}. {item.question}
        </span>

        <span className="faq-icon">
          {open ? "−" : "+"}
        </span>
      </button>

      {open && (
        <div className="faq-answer">
          <p>{item.answer}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQ() {
  const [active, setActive] = useState(null);

  return (
    <section className="faq-section">
      <div className="container">

        {/* Heading */}

        <div className="faq-heading">
          <div className="faq-title">

            <div className="title-lines">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <h2>
              Frequently Asked Questions About Sai Shirdi Cab
            </h2>

            <div className="title-lines">
              <span></span>
              <span></span>
              <span></span>
            </div>

          </div>

          <p>
            Have questions about our Sai Shirdi cab service?
            Find quick answers about cab bookings, doorstep pickup,
            one-way and round-trip taxi services, available vehicles,
            travel time and Sai Baba Darshan trips. Contact us anytime
            for assistance with your Shirdi journey.
          </p>
        </div>

        {/* FAQ Grid */}

        <div className="faq-grid">

          {/* Left FAQ */}

          <div>
            {faqLeft.map((item) => (
              <AccordionItem
                key={item.id}
                item={item}
                active={active}
                setActive={setActive}
              />
            ))}
          </div>

          {/* Right FAQ */}

          <div>
            {faqRight.map((item) => (
              <AccordionItem
                key={item.id}
                item={item}
                active={active}
                setActive={setActive}
              />
            ))}
          </div>

        </div>

        {/* Contact */}

        <div className="faq-contact">
          Still Have Questions About Your Shirdi Trip?

          <a href="/contact-us">
            Contact Us
          </a>
        </div>

      </div>
    </section>
  );
}
